// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UzU6mhJlm1I9tn {
  font-size: 14px;
  text-transform: uppercase;
}
.ecR55c2T_DsRiN {
  margin: var(--ds-space-400, 32px) var(--ds-space-0, 0) var(--ds-space-200, 16px) var(--ds-space-0, 0);
}
.KTQkESLWOfu7I_ {
  margin-bottom: var(--ds-space-200, 16px);
}
.vHs46PXeLQJy56:focus {
  outline: none;
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
`, ""]);
// Exports
export var step = `UzU6mhJlm1I9tn`;
export var summarySection = `ecR55c2T_DsRiN`;
export var submitError = `KTQkESLWOfu7I_`;
export var submit = `vHs46PXeLQJy56`;
export default ___CSS_LOADER_EXPORT___;
